import POSDiagram from './POSDiagram';

export default POSDiagram;
